module.exports = __webpack_public_path__ + "static/media/right-sidebar-left-img.0dda3a17.jpg";